import { useTranslation } from 'react-i18next'

import { RadioGroupModal } from '../../../Radio'
import { EMAIL_CREATION_FORM_FIELD_NAME_INSERT_REPLACE } from '../EmailCreationForm.constants'

import { INITIAL_VALUES } from './TemplateConfirmationModal.constants'
import { getOptions } from './TemplateConfirmationModal.utils'

function TemplateConfirmationModal(props) {
  const { t } = useTranslation()

  return (
    <RadioGroupModal
      {...props}
      formFieldsProps={{
        getOptions,
        name: EMAIL_CREATION_FORM_FIELD_NAME_INSERT_REPLACE,
        title: t('Modal.InsertReplaceTemplateConfirmationModalText'),
      }}
      initialValues={INITIAL_VALUES}
      title={t('Modal.InsertReplaceTemplateConfirmationModalTitle')}
    />
  )
}

export default TemplateConfirmationModal
